import { UAParser } from 'ua-parser-js';
import { GAME_COLORS } from '../constants';

export const userAgentInfo = UAParser(navigator.userAgent);

export const isFirefoxBrowser = userAgentInfo?.browser.name === 'Firefox';
export const isMobileDevice = userAgentInfo?.device?.type === 'mobile';
export const isTabletDevice = userAgentInfo?.device?.type === 'tablet';

console.log(userAgentInfo, 'userAgentInfo');
console.log(userAgentInfo?.device?.type, 'userAgentInfo?.device?.type');

export const reloadPage = (delay = 3000) => setTimeout(() => location.reload(), delay);

export function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

export const getUrlParam = paramName => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(paramName);
};

export const getFilteredValueFromArray = (arr, filterValue) => arr.filter(value => value !== filterValue.toString());

export const findAnotherMultiplier = (multipliers, avoidTarget) => {
    let foundColorMultiplier = false;

    return multipliers.find(m => {
        if (!foundColorMultiplier && m === avoidTarget) {
            foundColorMultiplier = true;
            return false;
        }
        return m;
    });
};

export const getDevParamsFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const devParams = [];

    for (const key of searchParams.keys()) {
        if (key.startsWith('DEV_')) {
            devParams.push([key, searchParams.get(key)]);
        }
    }

    return Object.fromEntries(devParams);
};

export const getRandomIndex = (arr: unknown[]): number => Math.floor(Math.random() * arr.length);

export const getRandomArrayElement = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

export const getRandomNumberFromTo = (min: number, max: number): number =>
    Math.floor(Math.random() * (max - min + 1)) + min;

export const getMinNumberBase = (num: number): string => Math.pow(10, num.toString().length - 1).toString();

export const randomInteger = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1) + min);
export const getStringLength = str => str.toString().length;
export const roundTo = (value, digits) => Number(value).toFixed(digits);

export const wait = ms => {
    let timeoutId = null;

    const promise = new Promise(resolve => (timeoutId = setTimeout(resolve, ms)));
    promise['cancel'] = () => {
        clearTimeout(timeoutId);
    };

    return promise;
};

export const getAverage = numbers => {
    const sum = numbers.reduce((acc, number) => acc + number, 0);
    const length = numbers.length;
    return sum / length;
};

export const dynamicTextSize = text => {
    return getStringLength(text) >= 5
        ? 'text-xs s-phone:text-sm phone:text-md desktop:text-lg'
        : 'text-xl desktop:text-3.5xl';
};

export const getCountDecimals = (value: string) => {
    return value.split('.')?.[1]?.length || 0;
};

export const getClientViewportHeight = () => document.body.clientHeight;

// example: 100000 => getNormalizeNumberWithDecimals(100000, 2, 2) =>  '1000.00'
export const getNormalizeNumberWithDecimals = (number, exponent = 2, decimal = 2) => {
    return Number(number / 10 ** exponent).toFixed(decimal);
};
// example: '1000.00' => getNormalizeShortNumber('1000.00', 2, 2) =>  100000
export const getLongFormatNumber = (number, exponent = 2) => {
    return Number(Number(number * 10 ** exponent).toFixed(0));
};

export const calculatePercentage = (num1, num2, decimal = 2) => {
    // handling divide 0 / 0
    if (num2 === 0) return 0;

    return Number(((num1 / num2) * 100).toFixed(decimal));
};

export const getCalculatedSum = arr => arr.reduce((total, bet) => total + bet, 0);

export const getVideoUrl = (videos, colorVideo, isWin) => {
    let filteredAssets;

    if (colorVideo && isWin) {
        filteredAssets = videos.filter(video => video.name.startsWith(`video_${colorVideo}_win`));
    } else {
        filteredAssets = videos.filter(video => video.name.startsWith(`video_${colorVideo}_fail`));
    }

    const randomIndex = getRandomNumberFromTo(0, filteredAssets.length - 1);

    return filteredAssets[randomIndex]?.url;
};

// Stops code execution by throwing an error (breakpoint in development build)
export function assert(message = '') {
    if (import.meta.env.VITE_IS_DEVELOPMENT) {
        console.error(message);
    }
}

export const repeatedlyFillArray = (arr: [], repeatNumber: number) => {
    const filledArray = [];

    for (let i = 0; i < repeatNumber; i++) {
        filledArray.push(...arr);
    }

    return filledArray;
};

export const getColorFromBonusType = bonusGameType => {
    if (bonusGameType === 'BALL_SPIN') return GAME_COLORS.PINK;
    if (bonusGameType === 'PLINKO') return GAME_COLORS.BLUE;
    if (bonusGameType === 'CASH_REELS') return GAME_COLORS.YELLOW;
    if (bonusGameType === 'FORTUNE_WHEEL') return GAME_COLORS.GREEN;
};

export const getBonusTypeFromColor = color => {
    if (color === GAME_COLORS.PINK) return 'BALL_SPIN';
    if (color === GAME_COLORS.BLUE) return 'PLINKO';
    if (color === GAME_COLORS.YELLOW) return 'CASH_REELS';
    if (color === GAME_COLORS.GREEN) return 'FORTUNE_WHEEL';
};
